"use client";

import React from 'react';
import { Box } from '@mui/material';

interface PublicPageLayoutProps {
  children: React.ReactNode;
}

export const PublicPageLayout: React.FC<PublicPageLayoutProps> = ({ children }) => {
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh', // Ensure layout takes full viewport height
      width: '100%',
      overflowX: 'visible',
    }}>
      {/* Header is provided globally by ClientProviders to avoid duplicates */}
      <Box component="main" sx={{ flexGrow: 1 }}>
        {children}
      </Box>
      {/* Footer is rendered globally by ClientProviders (ClientFooter) to ensure a single footer at page bottom */}
    </Box>
  );
};
